<div class="filter personnel-tab" ngModelGroup="personnelGroup" #personnel="ngModelGroup">
  <app-filter-item *ngIf="isAdmin" [title]="'Agency/Customer'" [value]="departmentValue" [clearFilter]="clearFilter('departmentId')">
    <mat-form-field appearance="outline" class="filter__select_full">
      <mat-select name="departmentId"
        placeholder="Agency/Customer"
        [disabled]="!isAdmin"
        [ngModel]="personnelGroup.departmentId"
        (ngModelChange)="onDepartmentChange($event)"
      >
        <mat-option *ngFor="let option of departmentOptions" [value]="option.value">
          {{option.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </app-filter-item>
  <app-filter-item [title]="'Officer Name'" [value]="officerNamesValue" [clearFilter]="clearFilter('officers')">
    <app-multiselect-with-search
      name="officers"
      [placeholder]="'Officer Name'"
      [options]="officerNameOptions"
      [(ngModel)]="personnelGroup.officers" />
  </app-filter-item>
</div>
